import { useEffect, useState } from "react";
import { SelectElement } from "../../../components/selectElement2";
import { SeleccionIcono } from "./SeleccionIcono";

const inputStyle = {
    width: '100%', padding: '11px 12px', borderRadius: 10,
    border: '1.5px solid #cbd5e1', marginTop: 4,
    boxSizing: 'border-box', fontSize: 14, background: 'white',
    outline: 'none', color: '#0f172a',
};

const labelStyle = { fontSize: 12, fontWeight: 700, color: '#475569' };

const initialForm = {
    ideUbicacion: '',
    codigoUbicacion: '',
    nombreUbicacion: '',
    tipoAtencion: '',
    complemento: '',
    identificador: '',
    sigla: '',
    orden: '',
    prioritario: '',
    cantidad: '',
    color: 'var(--color-primario-texto)',
    chkPrioritario: false,
    chkPermiteTraslado: false,
    icono: ''
}

export const CrearTipoAtencionModal = ({ show, onClose, onSave, iconos, ubicaciones, initialData = null,
    modo = "crear" }) => {

    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState({});

    const resetForm = () => {
        setForm(initialForm);
        setErrors({});
    };

    useEffect(() => {

        if (!show) {
            resetForm();
            return;
        }

        if (initialData) {

            setForm({
                ...initialForm,
                ...initialData,
                ideUbicacion: initialData.ideUbicacion || '',
                codigoUbicacion: initialData.codigoUbicacion || '',
                nombreUbicacion: initialData.nombreUbicacion || '',
                identificador: initialData.codigoTipoAtencion || '',
                chkPrioritario: initialData.indPrioridad === 1,
                chkPermiteTraslado: initialData.permiteTraslado === 1
            });
            setErrors({});

        } else {

            resetForm();

        }

    }, [show, initialData]);



    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : name === 'tipoAtencion' || name === 'identificador' || name === 'sigla' ? value.toUpperCase() : value
        }));

        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = {};

        if (modo === 'crear' && !form.ideUbicacion) {
            newErrors.ideUbicacion = 'Debe seleccionar la sede / ubicación';
        }

        if (!form.tipoAtencion.trim()) {
            newErrors.tipoAtencion = 'Debe ingresar el tipo de atención';
        }

        if (!form.identificador.trim()) {
            newErrors.identificador = 'Debe ingresar el identificador';
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        onSave({
            ...form,
            tipoAtencion: form.tipoAtencion.toUpperCase(),
            identificador: form.identificador.toUpperCase(),
            sigla: form.sigla.toUpperCase()
        });
    };

    const handleSelectUbicacion = (selected) => {
        setForm(prev => ({
            ...prev,
            ideUbicacion: selected.value,
            nombreUbicacion: selected.label,
            codigoUbicacion: selected.data
        }));
        setErrors(prev => ({ ...prev, ideUbicacion: '' }));
    };

    const onChangeIcono = (selected) => {
        setForm(prev => ({
            ...prev,
            icono: selected.value,

        }));
    };



    if (!show) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(15, 23, 42, 0.65)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, padding: 20, fontFamily: "'Inter', Arial, sans-serif",
        }}>
            <div style={{
                background: '#ffffff', borderRadius: 24, width: '100%',
                maxWidth: 760, maxHeight: '92vh', overflowY: 'auto',
                boxShadow: '0 25px 60px rgba(0,0,0,0.25)', border: '1px solid #e2e8f0',
            }}>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)',
                    padding: '20px 26px', color: 'var(--color-primario-contraste)',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    position: 'sticky', top: 0, zIndex: 1,
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div style={{
                            width: 44, height: 44, borderRadius: 14,
                            background: 'rgba(255,255,255,0.18)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 20,
                        }}>
                            <i className="fa-solid fa-list-check"></i>
                        </div>
                        <div>
                            <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18 }}>
                                {modo === 'crear' ? 'Crear Tipo de Atención' : 'Editar Tipo de Atención'}
                            </h4>
                            <p style={{ margin: '3px 0 0', opacity: 0.85, fontSize: 12.5 }}>
                                {modo === 'crear' ? 'Agrega un nuevo tipo de atención a la sede' : 'Modifica los datos del tipo de atención'}
                            </p>
                        </div>
                    </div>
                    <button type="button" onClick={onClose} style={{
                        background: 'rgba(255,255,255,0.15)', border: 'none', color: 'var(--color-primario-contraste)',
                        width: 34, height: 34, borderRadius: '50%', fontSize: 16, cursor: 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}><i className="fa-solid fa-xmark"></i></button>
                </div>

                <form onSubmit={handleSubmit} style={{ padding: 26 }}>

                    <div className="row g-3" style={{ marginBottom: 8 }}>

                        {modo === 'crear' ? (

                            <div className="col-12">
                                <label style={labelStyle}>Sede / Ubicación</label>
                                <div style={{ marginTop: 4 }}>
                                    <SelectElement
                                        options={ubicaciones}
                                        name={`idUbicacion`}
                                        isMulti={false}
                                        closeOnMenuSelect={true}
                                        value={ubicaciones.find(u => u.value === form.ideUbicacion)}
                                        onChange={handleSelectUbicacion}
                                        isClearable={false}
                                        fontSize="13.5px"
                                    />
                                </div>
                                {errors.ideUbicacion && (
                                    <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                        {errors.ideUbicacion}
                                    </div>
                                )}
                            </div>

                        ) : (

                            <div className="col-12">
                                <label style={labelStyle}>Sede</label>
                                <input
                                    value={form.nombreUbicacion || ''}
                                    disabled
                                    style={{ ...inputStyle, background: '#f8fafc', color: '#64748b', borderColor: '#e2e8f0' }}
                                />
                            </div>

                        )}

                        <div className="col-md-6">
                            <label style={labelStyle}>Tipo Atención</label>
                            <input
                                name="tipoAtencion"
                                value={form.tipoAtencion}
                                onChange={handleChange}
                                placeholder="Ej: PREFERENCIAL"
                                maxLength={45}
                                style={{
                                    ...inputStyle,
                                    textTransform: 'uppercase',
                                    borderColor: errors.tipoAtencion ? '#ef4444' : '#cbd5e1',
                                }}
                            />
                            {errors.tipoAtencion && (
                                <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                    {errors.tipoAtencion}
                                </div>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label style={labelStyle}>Complemento</label>
                            <input
                                name="complemento"
                                value={form.complemento}
                                onChange={handleChange}
                                placeholder="Ej: Para pacientes preferenciales"
                                maxLength={60}
                                style={inputStyle}
                            />
                        </div>

                        <div className="col-md-4">
                            <label style={labelStyle}>Identificador</label>
                            <input
                                name="identificador"
                                maxLength={2}
                                value={form.identificador}
                                onChange={handleChange}
                                placeholder="Ej: E1"
                                style={{
                                    ...inputStyle,
                                    textTransform: 'uppercase',
                                    borderColor: errors.identificador ? '#ef4444' : '#cbd5e1',
                                }}
                            />
                            {errors.identificador && (
                                <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                    {errors.identificador}
                                </div>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label style={labelStyle}>Sigla</label>
                            <input
                                name="sigla"
                                value={form.sigla}
                                onChange={handleChange}
                                placeholder="Ej: PREF"
                                maxLength={10}
                                style={{ ...inputStyle, textTransform: 'uppercase' }}
                            />
                        </div>

                        <div className="col-md-4">
                            <label style={labelStyle}>Orden</label>
                            <input
                                type="number"
                                name="orden"
                                value={form.orden}
                                onChange={handleChange}
                                placeholder="1"
                                min={1}
                                style={inputStyle}
                            />
                        </div>

                        <div className="col-md-4">
                            <label style={labelStyle}>Atn. Prioritaria</label>
                            <input
                                type="number"
                                name="prioritario"
                                value={form.prioritario}
                                onChange={handleChange}
                                placeholder="0"
                                min={0}
                                style={inputStyle}
                            />
                        </div>

                        <div className="col-md-4">
                            <label style={labelStyle}>Atn. Corriente</label>
                            <input
                                type="number"
                                name="cantidad"
                                value={form.cantidad}
                                onChange={handleChange}
                                placeholder="0"
                                min={0}
                                style={inputStyle}
                            />
                        </div>

                        <div className="col-md-4">
                            <label style={labelStyle}>Icono</label>
                            <SeleccionIcono
                                value={form.icono}
                                options={iconos}
                                onChange={onChangeIcono}
                            />
                        </div>

                        <div className="col-md-4">
                            <label style={labelStyle}>Color</label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 4 }}>
                                <input
                                    type="color"
                                    name="color"
                                    value={form.color}
                                    onChange={handleChange}
                                    style={{ width: 48, height: 44, border: '1.5px solid #cbd5e1', borderRadius: 10, padding: 3, background: 'white', cursor: 'pointer' }}
                                />
                                <span style={{ fontSize: 13, fontWeight: 700, color: '#475569', textTransform: 'uppercase' }}>
                                    {form.color}
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 d-flex align-items-end">
                            <label className="d-flex align-items-center gap-2" style={{ cursor: 'pointer', fontSize: 12, fontWeight: 700, color: '#475569' }}>
                                <input
                                    type="checkbox"
                                    name="chkPrioritario"
                                    checked={form.chkPrioritario}
                                    onChange={handleChange}
                                    style={{ width: 18, height: 18, accentColor: 'var(--color-primario)', cursor: 'pointer' }}
                                />
                                Prioritario
                            </label>
                        </div>

                        <div className="col-md-4 d-flex align-items-end">
                            <label style={{ cursor: 'pointer', fontSize: 12, fontWeight: 700, color: '#475569' }} className="d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    name="chkPermiteTraslado"
                                    checked={form.chkPermiteTraslado}
                                    onChange={handleChange}
                                    style={{ width: 18, height: 18, accentColor: 'var(--color-primario)', cursor: 'pointer' }}
                                />
                                Permite traslados
                            </label>
                        </div>

                    </div>

                    {/* Botones */}
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 26 }}>
                        <button type="button" onClick={onClose} style={{
                            padding: '12px 22px', borderRadius: 12, border: '1.5px solid #cbd5e1',
                            background: 'white', color: '#475569', fontWeight: 700, cursor: 'pointer', fontSize: 14,
                        }}>
                            Cancelar
                        </button>
                        <button type="submit" style={{
                            padding: '12px 28px', borderRadius: 12, border: 'none',
                            background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                            color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: 'pointer', fontSize: 14,
                            boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                            display: 'inline-flex', alignItems: 'center', gap: 8,
                        }}>
                            <i className="fa-solid fa-check"></i>
                            {modo === 'crear' ? 'Guardar' : 'Actualizar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};